"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedPieceInfo = SelectedPieceInfo;
const react_1 = __importDefault(require("react"));
const creatureDefinitions_1 = require("~/networking/creatureDefinitions");
const useStyles_1 = require("~/useStyles");
const TraitIcon_1 = require("../ui/TraitIcon");
const BalanceIcon_1 = require("../ui/icon/BalanceIcon");
const useSelectedPiece_1 = require("./hooks/useSelectedPiece");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        border: "1px solid #fff",
        borderRadius: "4px",
        padding: "4px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "8px",
        flex: 1,
    },
    info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    nameContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },
    hidden: {
        visibility: "hidden",
    },
    name: {
        "fontFamily": theme.typography.accent,
        "fontSize": "20px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            fontSize: "18px",
        },
    },
    price: {
        color: "#ffcd75",
        fontStyle: "italic",
    },
    stats: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    stat: {
        "fontSize": "14px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "10px",
        },
    },
    traits: {
        "height": "48px",
        "paddingBottom": "8px",
        "display": "flex",
        "flexDirection": "row",
        "& > *:not(:last-child)": {
            marginRight: "8px",
        },
        "@media (orientation: portrait) and (max-width: 430px)": {
            height: "32px",
        },
    },
    balanceIcon: {
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "12px",
        },
    },
}));
function SelectedPieceInfo() {
    const styles = useStyles();
    const selectedPiece = (0, useSelectedPiece_1.useSelectedPiece)();
    if (selectedPiece === null) {
        return null;
    }
    const definition = (0, creatureDefinitions_1.getCreatureDefinitionById)(selectedPiece.definitionId);
    if (!definition) {
        return null;
    }
    const stats = definition.stages[selectedPiece.stage];
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement("div", { className: styles.info },
            react_1.default.createElement("div", { className: styles.nameContainer },
                react_1.default.createElement("span", { className: styles.name }, definition.name),
                react_1.default.createElement(BalanceIcon_1.BalanceIcon, { amount: definition.cost, className: styles.balanceIcon })),
            react_1.default.createElement("div", { className: styles.traits }, selectedPiece.traits.map((trait) => (react_1.default.createElement(TraitIcon_1.TraitIcon, { key: trait, trait: trait, label: true }))))),
        react_1.default.createElement("div", { className: styles.stats },
            react_1.default.createElement("span", { className: styles.stat },
                "ATK ",
                stats.attack),
            react_1.default.createElement("span", { className: styles.stat },
                "DEF ",
                stats.defense),
            react_1.default.createElement("span", { className: styles.stat },
                "SPD ",
                stats.speed),
            react_1.default.createElement("span", { className: styles.stat },
                "HP ",
                stats.hp))));
}
